import React from "react"
import ConfirmRegistrationForm from "../../components/confirmregistration/ConfirmRegistration"

const ConfirmRegistrationPage = () => {
  return (
    <div>
      <ConfirmRegistrationForm />
    </div>
  )
}

export default ConfirmRegistrationPage
